import { Outlet } from 'react-router-dom';

export const FoodieOutlet = () => <Outlet />;
